import * as React from 'react';
import * as classNames from 'classnames/bind';
import { Link } from 'react-static';
import SVGInline from 'react-svg-inline';

import LanguageSwitcher from '../../containers/LanguageSwitcher/LanguageSwitcher';
import NavLink from '../../containers/Nav/NavLink';
import { NavLocale } from './nav.locale';

import logo from '../LogoRow/peering-logo.svg';

import styles from './Nav.scss';

export interface NavProps {
  isOpened?: boolean;
  onToggleMenu: () => void;
  onCloseMenu: () => void;
  onLinkClick: () => void;
  locale: NavLocale;
}

const cx = classNames.bind(styles);

const Nav: React.SFC<NavProps> = ({ isOpened, onToggleMenu, locale }) => {
  const className = cx('nav', {
    isOpened,
  });

  return (
    <nav className={className} id="nav">
      <div className={styles.mobileHeader}>
        <div className="container d-flex align-items-center justify-content-between">
          <Link to="/">
            <SVGInline svg={logo} className={styles.logo} />
          </Link>
          <div className={styles.buttonsContainer}>
            <LanguageSwitcher />
            <button className={styles.hamburger} onClick={onToggleMenu}>
              <span className={styles.hamburgerInside}>
                <span className={styles.hamburgerLine} />
                <span className={styles.hamburgerLine} />
                <span className={styles.hamburgerLine} />
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className={styles.mobileMenuContainer}>
        <div className="container">
          <div className={styles.linksGroupsContainer}>
            <div className={styles.linksGroup}>
              {locale.left.map(item => <NavLink item={item} key={item.href} />)}
            </div>
            <div className={styles.linksGroup}>
              {locale.right.map(item => <NavLink item={item} key={item.href} />)}
              <div className="d-none d-lg-flex align-items-center">
                <LanguageSwitcher />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.pageOverlay} onClick={onToggleMenu} />
    </nav>
  );
};

export default Nav;



// WEBPACK FOOTER //
// /www/client/src/components/Nav/Nav.tsx